import { isOver, set, unset } from "../../js/lib/util";

const breakpoint = 1024;
const featuredImageShiftScale = 0.3;
const SHOW_HERO_VIDEO_CLASS = "hero__video-wrapper--is-active";

export default (el) => {
  const parallaxImage = el.dataset.parallaxImage === "true";
  const featuredImages = Array.from(el.querySelectorAll(".js-hero-img"));
  const heroVideoTrigger = el.querySelector(
    ".js-hero-video-trigger"
  ) as HTMLElement;
  const heroVideoIframe = el.querySelector(
    ".js-hero-video-iframe"
  ) as HTMLIFrameElement;
  const heroVideoWrapper = el.querySelector(
    ".js-hero-video-wrapper"
  ) as HTMLElement;
  const heroVideo = el.querySelector(".js-hero-video") as HTMLVideoElement;
  const closeVideo = el.querySelector(".js-hero-video-close") as HTMLElement;

  const shift = (target, scale) => {
    if (!isOver(breakpoint)) {
      return;
    }
    const y = target.getBoundingClientRect().y;
    if (y > 0 || y < -100) {
      return;
    }

    target.style.transform = `translateY(calc(${Math.abs(y)}px * -${scale}))`;
  };

  if (parallaxImage && featuredImages.length) {
    if ("IntersectionObserver" in window) {
      let observerOptions = {
        root: null,
        rootMargin: "0px",
      };

      let intersectionCallback = (entries) => {
        if (entries[0].isIntersecting) {
          window.addEventListener("scroll", () => {
            featuredImages.map((featuredImage) => {
              shift(featuredImage, featuredImageShiftScale);
            });
          });
        }
      };
      let observer = new window.IntersectionObserver(
        intersectionCallback,
        observerOptions
      );
      observer.observe(el);
    }
  }

  if (heroVideoWrapper && heroVideoIframe && heroVideo && heroVideoTrigger) {
    heroVideo.addEventListener("ended", () => {
      unset(heroVideoWrapper, SHOW_HERO_VIDEO_CLASS);
    });

    heroVideoTrigger.addEventListener("click", () => {
      set(heroVideoWrapper, SHOW_HERO_VIDEO_CLASS);

      // ensure heroVideo starts from beginning
      heroVideo.currentTime = 0;
      heroVideo.play();
    });

    closeVideo.addEventListener("click", () => {
      unset(heroVideoWrapper, SHOW_HERO_VIDEO_CLASS);
      heroVideo.pause();
    });
  }
};
